import script from "./MobileSelectTrigger.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileSelectTrigger.vue?vue&type=script&setup=true&lang=js"

import "./MobileSelectTrigger.vue?vue&type=style&index=0&id=b57c5eea&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b57c5eea"]])

export default __exports__